import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { url } from 'src/config';
import { orgId } from 'src/constants';
import { getBrowser, getOS, userLocation } from 'src/utils/getUserInfo';
import { isLoading, isLoadingB } from './isLoading';
import { fetchUser } from './auth';

let userIp = '',
  referrerUrl = '';
if (document.referrer)
  referrerUrl = document.referrer.match(/:\/\/(.[^/]+)/)[1];

userLocation().then((location) => {
  if (location) userIp = location.query;
});

const initialState = {
  assignedExtensions: [],
  phoneNumbers: null,
  userRingGroups: [],
  virtualExtensions: [],
  availableExtensions: [],
  availablePhoneNumbers: null,
  mediaResources: [],
  voicemailResource: [],
  userIVR: [],
  timegroupResource: []
};
const slice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    getAssignedExtensions(state, action) {
      const { returnedRecords } = action.payload;
      state.assignedExtensions = returnedRecords;
    },
    getPhoneNumbers(state, action) {
      const { returnedRecords } = action.payload;
      state.phoneNumbers = returnedRecords;
    },
    getAvailablePhoneNumbers(state, action) {
      const { returnedRecords } = action.payload;
      state.availablePhoneNumbers = returnedRecords;
    },
    autoRenewNumber(state, action) {
      const { resource, autoRenewSetting } = action.payload;
      state.phoneNumbers.map((number) => {
        if (number.phoneNumber == resource)
          number.autoRenewSetting = autoRenewSetting;
      });
    },
    cancelPhoneNumber(state, action) {
      const { resource } = action.payload;
      state.phoneNumbers.map((number) => {
        if (number.phoneNumber == resource) number.status = 'inactive';
      });
    },
    deletePhoneNumber(state, action) {
      const { resource } = action.payload;
      state.phoneNumbers = state.phoneNumbers.filter(
        (obj) => obj.phoneNumber !== resource
      );
    },
    getVirtualExtensions(state, action) {
      const { returnedRecords } = action.payload;
      state.virtualExtensions = returnedRecords;
    },
    getRingGroups(state, action) {
      const { returnedRecords } = action.payload;
      state.userRingGroups = returnedRecords;
    },
    getUserIVR(state, action) {
      const { returnedRecords } = action.payload;
      state.userIVR = returnedRecords;
    },
    getAvailableExtensions(state, action) {
      state.availableExtensions = action.payload;
    },
    fetchMedia(state, action) {
      state.mediaResources = action.payload;
    },
    deleteAudio(state, action) {
      const { resource } = action.payload;
      state.mediaResources = state.mediaResources.filter(
        (obj) => obj.mediaAutoId !== resource
      );
    },
    editAudio(state, action) {
      const { resource, newName, duration, url } = action.payload;

      const findIndex = state.mediaResources.findIndex(
        (i) => i.mediaAutoId === resource
      );
      let newResource = {
        mediaAutoId: resource,
        mediaName: newName
          .replaceAll(' ', '_')
          .replaceAll('.', '')
          .concat('.mp3'),
        mediaDurationSecs: duration,
        mediaPlayUrl: url
      };

      state.mediaResources.splice(findIndex, 1, newResource);
    },
    fetchVoicemailResource(state, action) {
      state.voicemailResource = action.payload;
    },
    fetchTimegroupResource(state, action) {
      state.timegroupResource = action.payload;
    }
    //
  }
});

export const reducer = slice.reducer;

/** Vezeti Number Resources */
export const getPhoneNumbers = (data = {}) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);
    const response = await axios.post(`${url}phone-numbers/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseData } = response.data;
    dispatch(slice.actions.getPhoneNumbers(responseData));
    dispatch(isLoading(false));
  } catch (err) {
    dispatch(isLoading(false));
    console.log(err);
  }
};

export const getAvailablePhoneNumbers = (data) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    data.orgId = orgId;
    const response = await axios.post(`${url}available-phone-numbers/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseData } = response.data;
    dispatch(slice.actions.getAvailablePhoneNumbers(responseData));
    dispatch(isLoading(false));
  } catch (err) {
    dispatch(isLoading(false));
    console.log(err);
  }
};

export const buyNumber = (data) => async (dispatch) => {
  dispatch(isLoadingB(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}buy-phone-number/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    dispatch(isLoadingB(false));
    return response.data;
  } catch (err) {
    dispatch(isLoadingB(false));
    console.log(err);
  }
};
/** end */

// Resources --> src/views/resources

// Generic funcs

export const autoRenewResource = (data) => async (dispatch) => {
  dispatch(isLoadingB(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}auto-renew-this-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseData, responseCode } = response.data;
    dispatch(isLoadingB(false));
    if (responseCode == '00') {
      let autoRenewValue = responseData;
      autoRenewValue.autoRenewSetting = data.autoRenewSetting;
      if (data.type == 'phone')
        dispatch(slice.actions.autoRenewNumber(autoRenewValue));
    }
    return response.data;
  } catch (err) {
    dispatch(isLoadingB(false));
    console.log(err);
  }
};

export const cancelResource = (data) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}cancel-this-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode } = response.data;
    dispatch(isLoading(false));
    if (responseCode == '00') {
      if (data.type == 'phone') dispatch(slice.actions.cancelPhoneNumber(data));
    }
    return response.data;
  } catch (err) {
    dispatch(isLoading(false));
    console.log(err);
  }
};

/**
 * Delete Resource
 * @param {type, resource} data
 */
export const deleteResource = (data) => async (dispatch) => {
  dispatch(isLoadingB(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}delete-this-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode } = response.data;
    dispatch(isLoadingB(false));
    if (responseCode == '01') {
      throw new Error();
    }
    if (data.type == 'phone') dispatch(slice.actions.deletePhoneNumber(data));
    if (data.type == 'audio') dispatch(slice.actions.deleteAudio(data));
    return response.data;
  } catch (err) {
    dispatch(isLoadingB(false));
    return err;
  }
};

export const renameResource = (data) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}rename-this-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode, responseMessage } = response.data;
    if (responseCode == '01') {
      throw new Error(responseMessage);
    }
    if (data.type == 'audio') dispatch(slice.actions.editAudio(data));
    dispatch(isLoading(false));
    return response.data;
  } catch (err) {
    dispatch(isLoading(false));
    return err.message;
  }
};

// end

export const getRingGroups = () => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    let data = {
      orgId,
      userGlobalId: atob(current_vzid),
      userIpAddress: userIp,
      userDeviceType: getOS(),
      userRefererUrl: referrerUrl
    };
    const response = await axios.post(`${url}ring-groups-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseData } = response.data;
    dispatch(slice.actions.getRingGroups(responseData));
    dispatch(isLoading(false));
  } catch (err) {
    dispatch(isLoading(false));
    return err.message;
  }
};

export const getAssignedExtensions = () => async (dispatch) => {
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    let data = {
      orgId,
      userGlobalId: atob(current_vzid),
      userIpAddress: userIp,
      userDeviceType: getOS(),
      userRefererUrl: referrerUrl,
      extensionType: 'SIP'
    };
    const response = await axios.post(`${url}assigned-extensions/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseData } = response.data;
    dispatch(slice.actions.getAssignedExtensions(responseData));
  } catch (err) {
    return err.message;
  }
};

/** Resources --> Virtual Extension */

// Fetch all virtual extension

export const getVirtualExtensions = () => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    let data = {
      orgId,
      userGlobalId: atob(current_vzid),
      userIpAddress: userIp,
      userDeviceType: getOS(),
      userRefererUrl: referrerUrl
    };
    const response = await axios.post(
      `${url}virtual-extensions-resource/`,
      data,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    const { responseData } = response.data;
    dispatch(slice.actions.getVirtualExtensions(responseData));
    dispatch(isLoading(false));
  } catch (err) {
    dispatch(isLoading(false));
    console.log(err);
  }
};

export const addUpdateRingGroup = (data) => async (dispatch) => {
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.userGlobalId = atob(current_vzid);
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}add-update-a-ring-group/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (err) {
    return err.message;
  }
};

// Fetch available extension
export const getAvailableExtensions = () => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    let data = {
      orgId,
      userGlobalId: atob(current_vzid),
      userIpAddress: userIp,
      userDeviceType: getOS(),
      userRefererUrl: referrerUrl
    };
    const response = await axios.post(`${url}available-extensions/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode } = response.data;

    if (responseCode === '00') {
      const { returnedRecords } = response.data.responseData;

      dispatch(slice.actions.getAvailableExtensions(returnedRecords));
      dispatch(isLoading(false));
    } else {
      throw new Error();
    }
  } catch (err) {
    dispatch(isLoading(false));
    console.log(err);
  }
};

/**
 * createVirtualExtension
 *
 * @param {outboundCallerId, virtualExtAutoId, virtualExtNumber,
 * virtualExtName, virtualExtensionType, virtualExtDescription, gsmAndLandlinePhonesList
 *  mediaAutoId, virtualExtAnnouncementRepeatCounter, voiceMailAutoId } data
 */
export const createVirtualExtension = (data) => async (dispatch) => {
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );

    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);

    const response = await axios.post(
      `${url}add-update-a-virtual-extension/`,
      data,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );

    const { responseCode } = response.data;
    if (responseCode === '00') {
      dispatch(getVirtualExtensions());
      dispatch(getAvailableExtensions());
    }

    return response.data;
  } catch (err) {
    return err.message;
  }
};

/** End --> Virtual Extension */

// Media Resources

/**
 * FetchMedia
 * @param {type} data
 */
export const fetchMedia = (data) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );

    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);

    const response = await axios.post(`${url}media-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });

    const { responseCode } = response.data;

    if (responseCode === '00') {
      const { returnedRecords } = response.data.responseData;

      dispatch(slice.actions.fetchMedia(returnedRecords));
      dispatch(isLoading(false));
    } else {
      throw new Error();
    }
  } catch (err) {
    dispatch(isLoading(false));
    return err;
  }
};

/**
 * Upload Media
 * @param {mediaFile , type} formData
 */
export const uploadMedia = (formData) => async (dispatch) => {
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );

    const type = formData.get('type');

    formData.append('orgId', orgId);
    formData.append('userGlobalId', atob(current_vzid));

    const response = await axios.post(`${url}media-upload/`, formData, {
      headers: { 'Content-Type': 'application/json' }
    });

    const { responseCode } = response.data;

    if (responseCode === '00') {
      dispatch(fetchMedia({ type }));
      if (type == 'userProfilePicture') {
        dispatch(fetchUser());
      }
    }

    return response.data;
  } catch (err) {
    return err.message;
  }
};

/**
 * Resources --> voicemails
 *
 */
export const fetchVoicemailResource = () => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    let data = {
      orgId,
      userGlobalId: atob(current_vzid),
      userIpAddress: userIp,
      userDeviceType: getOS(),
      userRefererUrl: referrerUrl
    };
    const response = await axios.post(`${url}voicemail-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });

    const { responseCode, responseMessage } = response.data;

    if (responseCode === '01') {
      throw new Error(responseMessage);
    }
    const { returnedRecords } = response.data.responseData;

    dispatch(slice.actions.fetchVoicemailResource(returnedRecords));
    dispatch(isLoading(false));
  } catch (err) {
    dispatch(isLoading(false));
    console.error(err);
  }
};

/**
 * Resources --> timegroup
 *
 */
export const fetchTimegroupResource = () => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    let data = {
      orgId,
      userGlobalId: atob(current_vzid),
      userIpAddress: userIp,
      userDeviceType: getOS(),
      userRefererUrl: referrerUrl
    };
    const response = await axios.post(`${url}time-group-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });

    const { responseCode, responseMessage } = response.data;

    if (responseCode === '01') {
      throw new Error(responseMessage);
    }
    const { returnedRecords } = response.data.responseData;
    dispatch(slice.actions.fetchTimegroupResource(returnedRecords));
    dispatch(isLoading(false));
  } catch (err) {
    dispatch(isLoading(false));
    console.error(err);
  }
};

export const addUpdateTimegroup = (data) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}add-update-a-time-group/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    dispatch(isLoading(false));
    return response.data;
  } catch (err) {
    dispatch(isLoading(false));
    console.log(err);
  }
};

/**
 * Resources --> IVR
 *
 */

export const getUserIVR = () => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    let data = {
      orgId,
      userGlobalId: atob(current_vzid),
      userIpAddress: userIp,
      userDeviceType: getOS(),
      userRefererUrl: referrerUrl
    };
    const response = await axios.post(`${url}ivr-resource/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseData } = response.data;
    dispatch(slice.actions.getUserIVR(responseData));
    dispatch(isLoading(false));
  } catch (err) {
    dispatch(isLoading(false));
    return err.message;
  }
};

// AddUpdateAnIVR
export const addUpdateIVR = (data) => async (dispatch) => {
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.userGlobalId = atob(current_vzid);
    data.orgId = orgId;
    data.userBrowserType = getBrowser();
    data.userIpAddress = userIp;
    data.userDeviceType = getOS();
    data.userRefererUrl = referrerUrl;
    const response = await axios.post(`${url}add-update-an-ivr/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (err) {
    return err.message;
  }
};
